/*
 * Copyright 2017 The Closure Compiler Authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'require es6/object/is';
'require util/polyfill';

$jscomp.polyfill('Array.prototype.includes', function(orig) {
  if (orig) return orig;

  /**
   * Polyfills Array.prototype.includes.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
   *
   * @this {!IArrayLike<T>}
   * @param {T} searchElement
   * @param {number=} opt_fromIndex
   * @return {boolean}
   * @template T
   * @suppress {reportUnknownTypes}
   */
  var includes = function(searchElement, opt_fromIndex) {
    var array = this;
    if (array instanceof String) {
      array = /** @type {!IArrayLike} */ (String(array));
    }
    var len = array.length;
    for (var i = opt_fromIndex || 0; i < len; i++) {
      if (array[i] == searchElement || Object.is(array[i], searchElement)) {
        return true;
      }
    }
    return false;
  };

  return includes;
}, 'es7', 'es3');
